import type { CoachPreview } from '@/components/community/coachesCarousel'
import type { V1ProCoaches } from '@/domain/ProCoaches'

/** Coach listing rows as cards: the coach's author record plus the price. */
export function toCoachPreviews(rows: V1ProCoaches[]): CoachPreview[] {
    return rows
        .filter((c) => c.expand?.coach)
        .map((c) => ({
            ...c.expand!.coach!,
            pricePerCustomLesson: c.pricePerCustomLesson
        }))
}
